function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { DividerPosition } from '../../ResizeDivider';
export default (_ref => {
  let {
    width,
    minWidth,
    maxWidth,
    openRight,
    onResize,
    open,
    resizeAffordance = 16,
    closedWidth
  } = _ref;
  const [initialDragX, setInitialDragX] = useState(0);
  const [widthBeforeDrag, setWidthBeforeDrag] = useState(width);
  const [panelWidth, setPanelWidth] = useState(width);
  const [isResizing, setIsResizing] = useState(false);
  const [maxReached, setMaxReached] = useState(false);
  const [minReached, setMinReached] = useState(false);
  useEffect(() => {
    setPanelWidth(width);
    setWidthBeforeDrag(width);
  }, [width]);
  const handleMouseMove = useCallback(e => {
    if (isResizing && widthBeforeDrag && width) {
      e.persist();
      const deltaX = openRight ? e.pageX - initialDragX : initialDragX - e.pageX;
      const dragAmount = deltaX * window.devicePixelRatio;
      let newWidth = widthBeforeDrag + dragAmount / window.devicePixelRatio;
      if (minWidth && newWidth < minWidth) {
        newWidth = minWidth;
        setMinReached(true);
      } else if (maxWidth && newWidth > maxWidth) {
        newWidth = maxWidth;
        setMaxReached(true);
      } else {
        setMinReached(false);
        setMaxReached(false);
      }
      setPanelWidth(newWidth);
      if (onResize) {
        onResize(newWidth);
      }
    }
  }, [initialDragX, isResizing, maxWidth, minWidth, onResize, openRight, width, widthBeforeDrag]);
  const startResizing = useCallback(e => {
    if (!isResizing) {
      e.persist();
      setIsResizing(true);
      setInitialDragX(e.pageX);
    }
  }, [isResizing]);
  const stopResizing = useCallback(e => {
    if (isResizing) {
      e.persist();
      setIsResizing(false);
      setWidthBeforeDrag(panelWidth);
      setMinReached(false);
      setMaxReached(false);
    }
  }, [isResizing, panelWidth]);
  useEffect(() => {
    if (onResize) {
      if (open && panelWidth) {
        onResize(panelWidth);
      } else {
        onResize(0);
      }
    }
  }, [panelWidth, onResize, open]);
  const getResizeDividerProps = useCallback(() => ({
    onMouseDown: startResizing,
    onMouseUp: stopResizing,
    onMouseMove: handleMouseMove,
    position: openRight ? DividerPosition.right : DividerPosition.left,
    vertical: true,
    affordanceWidth: resizeAffordance,
    minReached,
    maxReached
  }), [handleMouseMove, maxReached, minReached, openRight, resizeAffordance, startResizing, stopResizing]);
  const getPanelProps = useCallback(props => _objectSpread({
    minWidth: closedWidth,
    open,
    width: panelWidth,
    disableAnimation: isResizing
  }, props), [closedWidth, isResizing, open, panelWidth]);
  return {
    getResizeDividerProps,
    getPanelProps
  };
});
//# sourceMappingURL=useResizePanel.js.map